<template lang="pug">
.dwgmain
  #dwgbox(ref="dwgbox" :style="boxStyle")
  fileName(v-if='dwgloaded')
  application(ref='dwgApplication' source="dwg" v-if='dwgloaded' type="dwg")
  el-select.dwgspace(v-model='selDwgSpace' size='small' placeholder='请选择' @change='changespace' v-show='dwgloaded')
    template(v-if="mlibEnabled")
      el-option(v-for='item in dwgSpaceList' :key='item.index' :label='item.fileName' :value='item.fileName')
    template(v-else)
      el-option(v-for='item in dwgSpaceList' :key='item.id' :label='item.picName' :value='item.picName')
</template>

<script>
/**
 * 警告 ！！
 * 请不要格式化文档，本来可读性很强了，不要很简单的组件整好几十行 ！！！
 * 对应组件的功能写到对应组件上，不明白别乱写，搞得看不懂我找你 ！！！
 */
import mongeService from "@/CommonDP/mongeView/service/monge-service.js";
import mongeApiMlib from "@/CommonDP/mongeView/mongeApiMlib";
import mongeCommon from "@/CommonDP/mongeView/common/mongeCommon";

import application from "@/views/mongeView/application.vue";
import fileName from "@/CommonDP/mongeView/dwgProMax/component/dwgFileName.vue";
import { mongeApp, mongeMutations } from "@/CommonDP/mongeView/store/mongeStore";
export default {
  components: { fileName, application },
  data () {
    return {
      dwgSpaceList: [], // 模型空间
      selDwgSpace: '',
      dwgloaded: false
    };
  },
  computed: {
    mlibEnabled() {
      return mongeApp.mlibEnabled;
    },
    dwgdata() {
      return JSON.parse(mongeApp.map.fileInfo);
    },
    spaceOfDwgData() {
      return mongeApp.map.spaceOfDwgData;
    },
    annotationData() {
      return mongeApp.map.annotationData;
    },
    annotationList() {
      return mongeApp.map.annotationList;
    },
    dicList() {
      return mongeApp.dicList;
    },
    hasList() {
      return mongeApp.hasList;
    },
    boxStyle() {
      return this.hasList ? { width: "calc(100% - 300px)" } : { width: "100%" };
    },
    // 状态字典
    statusList() {
      return this.dicList?.statusList || [];
    }
  },
  watch: {
    async hasList() {
      await this.$nextTick();
      mongeApiMlib.resize();
    },
    spaceOfDwgData(val, oldVal) {
      if (oldVal && val) {
        this.setSpace(JSON.parse(val));
      }
    }
  },
  mounted () {
    this.getFileInfo();
  },
  beforeDestroy () {
    // 问题列表改变布局位置
    mongeMutations.setHasList(false);
    mongeMutations.openLegend(false);
    mongeMutations.setOverlayList();
  },
  methods: {
    // 获取文件信息
    async getFileInfo() {
      const { fileId = "", versionId = "", i = "" } = this.$route.query;
      mongeMutations.setShareId(i);
      if (!fileId) {
        return Promise.reject("没有文件id，无法获取文件信息");
      }
      const { data } = await mongeService.getFileDetails(fileId, i);
      const urlData = {
        fileId,
        fileName: encodeURIComponent(data.fileName),
        prjId: data.prjId,
        fileVersion: versionId,
        enterpriseId: data.enterpriseId
      };
      document.title = data.fileName;
      mongeMutations.setDwgData(JSON.stringify(urlData));
      await this.getDwgData();
    },
    // 获取引擎图纸url参数
    async getDwgData() {
      const dwgdatas = this.dwgdata;
      const fileID = dwgdatas.fileId;
      const fileVersion = dwgdatas.fileVersion || '';
      await this.queryConvertMode();
      try {
        // 启动新的模式
        if (this.mlibEnabled) {
          const res = await mongeService.queryModelLightFilesFromMLib(fileID, fileVersion);
          this.dwgSpaceList = await mongeApiMlib.dealMongeFiles(res.data || {});
          // console.log("dwgSpaceList",this.dwgSpaceList);
          if (!this.dwgSpaceList) {
            this.$error("图纸轻量化失败");
            return false;
          }
          this.selDwgSpace = this.dwgSpaceList[0].fileName;// 空间名称
          mongeMutations.setSpaceOfDwgData(JSON.stringify(this.selDwgSpace));
          this.loadDwg(this.dwgSpaceList[0]);
        } else {
          const res = await mongeService.queryDwgSpace(fileID, fileVersion);
          const list = mongeApiMlib.assembleUrl(res.data) || [];
          if (list.length > 0) {
            this.dwgSpaceList = mongeApiMlib.assembleUrl(res.data).map(e => {
              return { index: e.id, fileName: e.picName, ...e };
            }) || [];
            this.selDwgSpace = this.dwgSpaceList[0].fileName;// 空间名称
            mongeMutations.setSpaceOfDwgData(JSON.stringify(this.selDwgSpace));
            this.loadDwg(this.dwgSpaceList[0].picsurl);
          } else {
            this.$warn("图纸已经被删除或者加载方式异常");
          }
        }
      } catch (error) {
        debugger;
        console.debug(error);
        this.$error(error.message || "加载图纸错误");
      }
    },
    async queryConvertMode() {
      try {
        const res = await mongeService.queryConvertMode(this.dwgdata.fileId, this.dwgdata.fileVersion || '');
        mongeMutations.changeMlibEnabled(!!(res.data && res.data === 1));
      } catch (e) {
        mongeMutations.changeMlibEnabled(false);
      }
      return Promise.resolve();
    },
    /**
   * 入口
   * @param { 当前空间的url } dwgdata
   */
    async loadDwg(picsurl) {
      await mongeApiMlib.loadDwg(picsurl, "dwgbox", false);
      this.dwgloaded = true;
    },
    // 定位时、空间不同
    async setSpace(val) {
      this.selDwgSpace = val;
      let url = "";
      if (this.mlibEnabled) {
        url = this.dwgSpaceList.find(e => e.fileName === val);
      } else {
        const data = this.dwgSpaceList.find(e => e.picName === val);
        url = data.picsurl;
      }
      await mongeApiMlib.loadMap(url, "dwgbox");
      this.dwgloaded = true;
      if (this.hasList && this.annotationData) { // 定位云线
        mongeCommon.fitToQs(this.annotationData, this.statusList, "dwg");
      } else if (this.hasList && this.annotationList.length > 0) { // 展示云线
        mongeCommon.showAllAnnotation(this.annotationList, this.statusList, "dwg");
      }
    },
    // 空间切换
    async changespace(val) {
      mongeMutations.setSpaceOfDwgData(JSON.stringify(val));
    }
  }
};
</script>

<style lang="scss" scoped>
.dwgmain{
  width: 100%;
  height: 100%;
  position: relative;
  overflow: hidden;
  .default-theme{
    height: 100%;
  }
  #dwgbox {
    width: 100%;
    height: 100%;
    min-width: 800px;
    min-height: 300px;
  }
  .qslist{
    width: calc(100% - 300px);
  }
  .dwgspace{
    position: absolute;
    width: 150px;
    left: 5px;
    bottom: 10px;
  }
}
</style>
